<template>
  <!-- google 城市搜索组件 -->
  <div class="inputSearch">
    <input type="text" class="inputSear" v-model="inputText" ref="ipt" :placeholder="setPlaceholder" :style="{width:setWidth,height:height,}" @focus="focusInput" @click="RecentShow" @keydown="keydown($event)" @input="getInputVal(inputText)" @blur="blurInput" />
    <div class="dataBox" v-show="isShow != 3" style="min-width:246px;" id="CitySearch">
      <div v-show="isShow == 0">
        <div class="Recent"> My Records</div>
        <div class="sepTipsMsg" style="text-align: center;padding: 5px;" v-show="!RecentList.length">No result</div>
        <el-scrollbar style="height:100%;min-width: 246px">
          <ul style="max-height:200px">
            <li class="es" style="color:#888" v-for="(item,index) in RecentList" @click="getText(item)" :key="index" :class="{isActive:index==isIndex}" :id="index" @mouseover="clearKeydown(index)">
              <span class="fa fa-Airdingwei"></span>
              {{item.description}}
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <div v-show="isShow != 2">
        <div class="Recent">Destination City</div>
        <ul v-show="isShow != 2">
          <li class="es" v-for="(item,index) in queryList" @click="getText(item)" :key="index" :class="{isActive:(isShow==0 ? RecentList.length+index :index)==isIndex}" :id="index" @mouseover="clearKeydownQuery(index)">
            <span class="fa fa-Airdingwei"></span>
            {{item.description}}
          </li>
          <div v-show="isShow != 2 && !queryList.length">
            <div class="sepTipsMsg">No result</div>
          </div>
        </ul>
      </div>
      <div v-show="isShow == 2">
        <div class="Recent">Destination City</div>
        <ul>
          <div class="sepTipsMsg">No result</div>
        </ul>
      </div>
      <div class="google-warp">
        <span class="font12" style="color:gray">powered by </span>
        <span class="google-title" style="color:#4086f4">G</span>
        <span class="google-title" style="color:#eb4132">o</span>
        <span class="google-title" style="color:#fbbd01">o</span>
        <span class="google-title" style="color:#4086f4">g</span>
        <span class="google-title" style="color:#31aa52">l</span>
        <span class="google-title" style="color:#eb4132">e</span>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import bus from '@/ask/eventBus';
import { post, fetch, Del, put } from "@/ask/axios";
export default {
  props: {
    setPlaceholder: { type: String }, //输入框默认值
    setWidth: { type: String }, //宽度
    height: { type: String }, //高度
    CountryCode: { type: String }, // 当前国家二字吗
    expNamePro: { type: String }, // 当前国家英文名
    Recent: { type: Array }, // 当前国家二字码
    setData: { type: Object }, // 设置属性
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: "",
      },
      first: true,
      RecentList: [],
      inputFocus: false, //聚焦
      isShow: 3, //0是否显示最近查询 1:数据显示，2：数据无结果显示 3.不显示
      inputText: '',//输入
      disappear: true,
      key: "",
      queryList: [],
      isIndex: -1,
      curList: '',//当前list
    }
  },
  created() {
    this.getCity()
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.inputFocus) {
        var sp = document.getElementById("CitySearch");
        if (sp && !sp.contains(e.target)) {
          this.isShow = 3
        }
      }
    })
  },
  watch: {
    expNamePro(val, oldVal) {
      if (this.$route.query.AirPirceStore) {
        if (this.first) {
          this.first = false
        } else {
          this.inputText = ''
          this.curList = ''
          this.$emit('byCityValue', this.curList)
        }
      } else {
        this.inputText = ''
        this.curList = ''
        this.$emit('byCityValue', this.curList)
      }
    }
  },
  methods: {
    //---------基础设置方法----------//
    //点击input自动选中里面的值

    getCity() {
      if (JSON.stringify(this.setData) !== "{}") {
        let description = this.setData.DestAddressDesc.split(',').splice(0, this.setData.DestAddressDesc.split(',').length - 1).join(',')
        let CurList = {
          Primary_Description: this.setData.DestAddressDesc,
          description: description,
          id: "",
          lstTerms: this.setData.lstTerms,
          terms: [],
        }
        this.inputText = description
        this.$emit('byCityValue', CurList)
      }
    },
    // 需要更改的
    async SearchCity() {
      let res = await this.searchApi()
      if (res.Results) {
        if (res.Results.length > 0) {
          this.queryList = res.Results
          if (this.inputText == '') {
            this.isShow = 0
          } else {
            this.isShow = 1
          }
        } else {
          this.isShow = 2
        }
      }
    },
    searchApi() {
      let that = this;
      let countryNameEn = this.CountryCode
      // if( this.setData.CountryEn) {
      //   console.log( this.setData,"何方神圣")
      //   countryNameEn = this.setData.CountryEn
      // } 
      that.api.param = {
        countryNameEn: countryNameEn,
        inputAddr: this.inputText,
        origin: 1
      }
      this.api.url = this.$api04 + "/Air/api/SumDoorDistance/GoogleMapsPlaceAutoCompLete"
      return new Promise((resolve, reject) => {
        fetch(this.api.url, this.api.param).then((res) => {
          resolve(res);
        });
      });
    },

    focusInput: function (e) {
      this.inputFocus = true
      if (!this.expNamePro) {
        this.isShow = 2
        return false
      }
      let List = []
      for (let index = 0; index < this.Recent.length; index++) {
        if (this.Recent[index].Counrty == this.CountryCode) {
          List.push(this.Recent[index].List)
        }
      }
      this.isShow = 0
      this.RecentList = List
      if (this.inputText.trim() == '') {
        this.queryList = []
        this.isShow = 0
      } else {
        this.SearchCity()
      }
      this.$refs.ipt.select(); // or e.currentTarget.select();
      this.first = true
    },

    getInputVal(val) {
      if (!this.expNamePro) {
        this.isShow = 2
        return false
      }
      this.SearchCity(); //搜索数据接口
    },

    RecentShow() {
      if (this.isShow == 3) {
        this.isShow = 0
      }
    },

    //键盘方法
    keydown(e) {
      let showList = ''
      let allList = this.RecentList.concat(this.queryList)
      if (this.isShow == 0) {
        showList = allList.length
      } else {
        showList = this.queryList.length
      }
      if (e.keyCode == 40) {//下键
        this.isIndex++;
        if (this.isIndex > showList - 1) {
          this.isIndex = 0;
        }
      } else if (e.keyCode == 38) {//上
        this.isIndex--;
        if (this.isIndex < 0) {
          this.isIndex = showList - 1;
        }
      } else if (e.keyCode == 13) {//回车
        if (this.isIndex >= 0) {
          if (this.isShow == 0) {
            this.curList = allList[this.isIndex]
          } else {
            this.curList = this.queryList[this.isIndex]
          }
          var curText = `${this.curList.description}`
          this.inputText = curText;
          this.isShow = 3
          this.disappear = false
          this.$emit('byCityValue', this.curList)
        }
        this.isIndex = -1;
      }
    },

    blurInput() {
      this.inputFocus = false
      // 延迟等待getText事件
      this.disappear = true
      setTimeout(() => {
        var curText = `${this.curList.description}`
        if (this.inputText != curText && this.disappear) {
          this.inputText = ''
          this.curList = ''
        }
        this.$emit('byCityValue', this.curList)
        // this.isShow = 3
      }, 200)
    },

    //鼠标移入时清除键盘事件
    clearKeydown(index) {
      this.isIndex = index;
    },
    clearKeydownQuery(index) {
      if (this.isShow == 0) {
        index = this.RecentList.length + index
      }
      this.isIndex = index;
    },
    //----------热门数据------------//

    //点击热门和搜索数据选中
    getText(item) {
      this.curList = item
      var curText = `${this.curList.description}`
      //console.log(curText)
      this.inputText = curText; //text赋值
      this.isShow = 3 //关闭下拉框
      this.disappear = false
      this.$emit('byCityValue', item)
    },
    //热门数据接口


    //----------搜索城市数据------------//
    //货物input输入框输入值

  }
}
</script>
<style lang="css" scoped>
.inputSearch {
  position: relative;
}
.inputSear {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0 5px;
}

.dataBox {
  overflow-y: hidden;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 5px;
  position: absolute;
  top: 31px;
  left: 0px;
  z-index: 66;
  -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}
.dataBox ul li {
  cursor: pointer;
  color: #888;
}
.dataBox ul li:hover {
  background: #f5f7fa;
}
.dataBox ul li {
  padding: 0 5px;
}
.Recent {
  font-weight: 700;
  padding-left: 6px;
}
.isActive {
  background-color: #f5f7fa !important;
}
.es {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sepTipsMsg {
  color: #999;
  text-align: center;
}
.google-warp {
  font-size: 0;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  border-top: 1px solid #eaeaea;
}
.google-title {
  font-size: 13px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/air/component/citySearch.vue